// src/config/config.js

const config = {
  WORKER_BASE_URL: 'https://files.fitplannerhub.org',
  REACT_APP_R2_AUTH_TOKEN: 'sk_test_4d8930a7aefb4bd5a8f23b7236fd0143'
};

export default config;
